if(typeof __WEBPACK_EXTERNAL_MODULE__25860__ === 'undefined') { var e = new Error("Cannot find module 'keytar'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = __WEBPACK_EXTERNAL_MODULE__25860__;